import { ICON_SIZE } from './constants';
export const getCorrectSize = (size) => {
    if (typeof size === 'object' && Object.keys(size).length > 0) {
        return {
            correctSize: undefined,
            correctSizes: size,
        };
    }
    return {
        correctSize: Object.values(ICON_SIZE).includes(size)
            ? size
            : ICON_SIZE.xs,
        correctSizes: undefined,
    };
};
